// extracted by mini-css-extract-plugin
module.exports = {"root":"MerchantCouponCalendar_root__P942k"};